export const STATUS_META = {
  created: { label: "Created", cls: "bg-slate-100 text-slate-700 border-slate-300", dot: "#64748B" },
  dispatched: { label: "Dispatched", cls: "bg-yellow-100 text-yellow-800 border-yellow-300", dot: "#EAB308" },
  in_transit: { label: "In Transit", cls: "bg-blue-100 text-blue-700 border-blue-300", dot: "#2563EB" },
  delivered: { label: "Delivered", cls: "bg-green-100 text-green-700 border-green-300", dot: "#16A34A" },
};

export default function StatusBadge({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.created;
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${m.cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.dot }} />
      {m.label}
    </span>
  );
}
